import React, { useState, useEffect, useRef } from "react";
import ProductFilter from "./ProductFilter";
import ProductList from "./ProductList";
import Icons from "./Icons";
import api, { getCache, setCache } from "./api";
import { useNavigate, useLocation } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import "./ProductListWrapper.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useFilter } from "../context/FilterContext";

export default function ProductListWrapper({
  title = "",
  prefix = null,
  surfix = null,
  breadcrumbs = null,
}) {
  const location = useLocation();
  const { rec_for_you } = location.state || {};
  const [filterItems, setFilterItems] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedCounts, setSelectedCounts] = useState({});
  const [synced, setSynced] = useState(false);

  const { filters } = useFilter();
  const navigate = useNavigate();
  const hasSyncedRef = useRef(false);

  // Fetch and cache filters
  const fetchFilterData = async () => {
    let data = getCache("filterItemsV2");
    if (!data) {
      try {
        const response = await api.get("/v2/filters");
        data = await response.data;
        setCache("filterItemsV2", data);
      } catch (error) {
        console.error(error);
      }
    }
    setFilterItems(data);
  };

  useEffect(() => {
    fetchFilterData();
  }, []);

  // Sync filters with URL while preserving other params like "q"
  useEffect(() => {
    const currentParams = new URLSearchParams(location.search);
    const mergedParams = new URLSearchParams(location.search); // start with existing params

    Object.entries(filters).forEach(([key, values]) => {
      mergedParams.delete(key); // remove existing key to reset
      values.forEach((value) => mergedParams.append(key, value));
    });

    const newSearch = mergedParams.toString();
    const currentSearch = currentParams.toString();

    if (currentSearch !== newSearch && !hasSyncedRef.current) {
      hasSyncedRef.current = true;
      navigate(`${location.pathname}?${newSearch}`, { replace: true });
    } else {
      setSynced(true);
    }
  }, [filters, location.pathname, location.search, navigate]);

  const onSelectedCountsChange = (updatedCounts) => {
    setSelectedCounts(updatedCounts);
  };

  return (
    <div className="row gx-5 my-4 flex-fill">
      {/* <div className="flex-grow-1">
        <p className="header">{title}</p>
      </div> */}

      <div className="col-lg-3 d-none d-lg-block">
        <div className="sidebar-filter-container">
          <ProductFilter
            items={filterItems}
            id="sidebar"
            selectedCounts={selectedCounts}
            onSelectedCountsChange={onSelectedCountsChange}
            accordionId="product-filter-accordion-sidebar"
          />
        </div>
      </div>

      <div className="col">
        {/* Fixed heading to appear without unwanted whitespace */}
        <p className="header mb-3">{title}</p>
        {breadcrumbs && breadcrumbs}
        <div className="d-flex align-items-center">
          <div className="col-auto d-lg-none">
            <Button
              variant="outline-secondary"
              className="d-flex align-items-center gap-2"
              onClick={() => setShowFilter(true)}
            >
              <Icons.Preferences />
              <span className="small-filter">Filter</span>
            </Button>
          </div>
        </div>

        {prefix && <div className="mt-4">{prefix}</div>}

        {synced && <ProductList rec_for_you={rec_for_you} filters={filters} />}

        {surfix && <div>{surfix}</div>}
      </div>

      <div className="d-lg-none">
        <Offcanvas
          show={showFilter}
          onHide={() => setShowFilter(false)}
          placement="start"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="offcanvas-filter-container">
              <Accordion id="offcanvas-accordion">
                <ProductFilter
                  items={filterItems}
                  id="small-sidebar-filter"
                  selectedCounts={selectedCounts}
                  onSelectedCountsChange={onSelectedCountsChange}
                  accordionId="product-filter-accordion-offcanvas"
                />
              </Accordion>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </div>
  );
}
